import * as THREE from 'three';
import { MaterialsNamesType, SupportMaterialsType, SupportProsType } from '../../types';
import { SupportsGroup } from './SupportsGrpoup';
import dataJson from '../../../assets/jsons/supportsData.json';
import { ReturnDirectionsParamsType } from './types';
import { Edit } from '../../work/Edit';

const DataSupports = dataJson as SupportProsType;

export function visibleDirection(point: THREE.Vector3, direct: THREE.Vector3, len: number) {
  const l = len || 1;
  const arrow = new THREE.ArrowHelper(direct.clone(), point, l, Math.random() * 0xffffff);
  Edit?.Load?.scene.add(arrow);
  setTimeout(() => {
    Edit?.Load?.scene.remove(arrow);
  }, 8000);
}
export function addSupportMesh(
  scope: SupportsGroup,
  position: THREE.Vector3
): THREE.Mesh | undefined {
  const currentHeight = scope.contour[0].y;
  const { height, compensatingLiningAmount } = getHeightSupport(
    position,
    currentHeight,
    scope.planesZeroIntersected
  );
  scope.compensatingLining += compensatingLiningAmount;
  if (height <= 0) {
    return;
  }
  const materialStaff = getMaterialOnHeight(scope, height - scope.depthTile);
  if (materialStaff) {
    const mesh = new THREE.Mesh(
      SupportsGroup.geometrySupport,
      SupportsGroup.materialsSupport?.materials[materialStaff]
    );

    scope.add(mesh);
    mesh.position.copy(position.clone()); //.setY(currentHeight - height));
    return mesh;
  }
}
export function getSupportGeometry(): THREE.RingGeometry {
  const geometrySupport = new THREE.RingGeometry(0.05, 0.1, 16);
  geometrySupport.applyMatrix4(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
  return geometrySupport;
}
export function getMaterialsSupports(): SupportMaterialsType | null {
  const {
    basicStandard: { modifications },
  } = DataSupports;
  const materials: SupportMaterialsType['materials'] = {};
  for (const key in modifications) {
    materials[modifications[key].material] = new THREE.MeshBasicMaterial({
      color: modifications[key].color,
    });
  }
  return { materials };
}

const COMPENSATION_DEG = 2;
const COMPENSATION_HEIGHT = 0.007;
function getHeightSupport(
  supportPos: THREE.Vector3,
  currentHeight: number,
  planesIntersected: Array<THREE.Mesh>
): { height: number; compensatingLiningAmount: number } {
  if (planesIntersected.length > 0) {
    const origin = supportPos.clone().setY(currentHeight);
    SupportsGroup.raycaster.set(origin, SupportsGroup.directBottom);
    const inters = SupportsGroup.raycaster.intersectObjects(planesIntersected);
    if (inters.length > 0) {
      let compensatingLiningAmount = 0;
      let compensationHeight = 0;
      if (Edit.selectModificationSupport === 'basicStandard' && inters[0].face?.normal) {
        const vecY = new THREE.Vector3(0, 1, 0);
        const slopped = THREE.MathUtils.radToDeg(vecY.angleTo(inters[0].face.normal));
        compensatingLiningAmount = Math.round(slopped / COMPENSATION_DEG);
        compensationHeight = compensatingLiningAmount * COMPENSATION_HEIGHT;
        // console.log(slopped);
      }

      return { height: inters[0].distance - compensationHeight, compensatingLiningAmount };
    }
    // console.log(pointIntersLine.distanceTo(supportPos));
  }
  return { height: currentHeight, compensatingLiningAmount: 0 };
}
function getMaterialOnHeight(scope: SupportsGroup, height: number): MaterialsNamesType | undefined {
  const { modifications } = DataSupports[scope.selectModificationSupport];
  const keys = Object.keys(modifications);
  let materialName: MaterialsNamesType = 'materialSupport';
  let title = 'noName';
  let color = '#fff';

  for (let i = 0; i < keys.length; i++) {
    const item = keys[i];
    if (height >= modifications[item].min / 1000 && height <= modifications[item].max / 1000) {
      materialName = modifications[item].material;
      title = item;
      color = modifications[item].color;
      break;
    }
  }
  if (title === 'noName') {
    return;
  }

  // if (title === 'noName') {
  //   console.log('height no name', height);
  // }

  if (!scope.selectSupports) {
    scope.selectSupports = {
      [title]: {
        color: color,
        quantity: 1,
      },
    };
  } //
  else if (!Object.hasOwn(scope.selectSupports, title)) {
    scope.selectSupports[title] = {
      color,
      quantity: 1,
    };
  } //
  else {
    scope.selectSupports[title].color = color;
    scope.selectSupports[title].quantity += 1;
  }

  return materialName;
}
export function getParamsBetweenTwoPoints(
  start: THREE.Vector3,
  end: THREE.Vector3
): ReturnDirectionsParamsType {
  const direction = end.clone().sub(start).normalize();
  const distance = start.distanceTo(end);
  const direction90 = direction.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2);
  const directionMinus90 = direction
    .clone()
    .applyAxisAngle(new THREE.Vector3(0, 1, 0), -Math.PI / 2);

  return {
    direction,
    distance,
    direction90,
    directionMinus90,
  };
}
/*function getPointNearIntersectedLineFullDistance(
  origin: THREE.Vector3,
  direct: THREE.Vector3,
  lineInters: LineIntersType[]
): THREE.Vector3 {
  const pointInters = new THREE.Vector3();
  let dist = Infinity;
  for (let i = 0; i < lineInters.length; i++) {
    const line = lineInters[i];
    const pointIntersLine = new THREE.Vector3();
    SupportsGroup.ray.set(origin, direct);
    const _dist = SupportsGroup.ray.distanceSqToSegment(
      line.start,
      line.end,
      undefined,
      pointIntersLine
    );

    if (_dist < dist) {
      pointInters.copy(pointIntersLine);
      dist = _dist;
    }
  }
  return pointInters;
}*/
